import Model from './Model'

export default class Suggestion extends Model {
  resource() {
    return 'suggestions'
  }
}
